module.exports = __webpack_public_path__ + "img/8f4d5a7329a3efb49591c6509f5d713e.png";